import grtAi from './grtAi';
import skillStore from './grtAi/skill';
import simulation from './grtAi/simulation';
import sessionStore from './grtAi/session';
import chatStore from './grtAi/chat';
import voiceCallStore from './grtAi/voiceCall';
import aipptStore from './grtAi/aippt';
import multimodalStore from './grtAi/multimodal';
import modalStore from './grtAi/modal';
const grtStore = {
    grtAi,
    skillStore,
    simulation,
    sessionStore,
    chatStore,
    voiceCallStore,
    aipptStore,
    multimodalStore,
    modalStore
};

export default grtStore;
